import { render, staticRenderFns } from "./ImagCropper.vue?vue&type=template&id=2095ef4a&scoped=true&"
import script from "./ImagCropper.vue?vue&type=script&lang=js&"
export * from "./ImagCropper.vue?vue&type=script&lang=js&"
import style0 from "./ImagCropper.vue?vue&type=style&index=0&id=2095ef4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2095ef4a",
  null
  
)

export default component.exports